// @flow
import * as actions from './actions';

const initialState = {};

export default function searchReducer(state: Object = initialState, action: Object) {
  switch (action.type) {
    case actions.FETCH_HUBPAGE_START: {
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: '',
      });
    }

    case actions.FETCH_HUBPAGE_SUCCESS: {
      return Object.assign({}, action.payload, state, {
        isFetching: false,
        errorMessage: '',
      });
    }

    case actions.FETCH_HUBPAGE_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.payload.message,
      });
    }

    default: {
      return state;
    }
    
  }
}
